import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const Reminders: React.FC<PropsType> = ({ size = 50, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
    >
      <g clip-path="url(#clip0_272_13089)">
        <path
          d="M12.4997 30.4167C12.4997 40.3118 20.5212 48.3333 30.4163 48.3333C34.0594 48.3333 37.4485 47.246 40.2769 45.3782C41.4788 44.5845 46.1627 46.9965 47.1386 45.9444C47.9808 45.0364 45.1468 40.6941 45.788 39.6263C47.4039 36.935 48.333 33.7843 48.333 30.4167C48.333 20.5216 40.3114 12.5 30.4163 12.5C20.5212 12.5 12.4997 20.5216 12.4997 30.4167Z"
          stroke="#003125"
          stroke-width="3"
        />
        <path
          d="M37.5003 19.5833C37.5003 29.4784 29.4788 37.5 19.5837 37.5C15.9406 37.5 12.5515 36.4126 9.72311 34.5448C8.52122 33.7511 3.83726 36.1631 2.86144 35.1111C2.01915 34.203 4.85319 29.8608 4.21202 28.7929C2.59612 26.1016 1.66699 22.951 1.66699 19.5833C1.66699 9.68819 9.68856 1.66663 19.5837 1.66663C29.4788 1.66663 37.5003 9.68819 37.5003 19.5833Z"
          fill="#19FFBE"
          stroke="#003125"
          stroke-width="3"
        />
        <path d="M12.5 16.6666H27.0833" stroke="#003125" stroke-width="3" stroke-linecap="round" />
        <path d="M12.5 23.3334H27.0833" stroke="#003125" stroke-width="3" stroke-linecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_272_13089">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Reminders;
